import {AxiosContext} from 'components/utils/AxiosProvider';
import {useCallback, useContext, useEffect, useState} from 'react';

const useGetEndpointActive = (endpoint, useCached = true, cache = true) => {
    const [isLoading, setIsLoading] = useState(null);
    const [data, setData] = useState(null);
    const [authReady, setAuthReady] = useState(null);
    const [error, setError] = useState(null);
    const {client: axiosClient, ready} = useContext(AxiosContext);

    // Expose auth ready
    useEffect(() => {
        setAuthReady(ready);
    }, [ready]);

    const onDataFetched = result => {
        setData(result.data);
        setError(null);
        setIsLoading(false);
    };

    const onError = error => {
        setIsLoading(false);
        setError(error.response?.data?.message);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const get = useCallback(
        axiosClient
            ? (params = null, url = null) => {
                  setData(null);
                  setIsLoading(true);
                  setError(null);
                  return axiosClient
                      .get(url ? `${endpoint}/${url}` : endpoint, {
                          params: params,
                          useCached: params?.useCached || useCached,
                          cache: cache,
                      })
                      .then(onDataFetched)
                      .catch(onError);
              }
            : null,
        [axiosClient, cache, endpoint, useCached]
    );

    const reset = () => {
        setIsLoading(null);
        setData(null);
        setError(null);
    };

    return {
        authReady,
        get,
        data,
        isLoading,
        error,
        reset,
    };
};

const useGetUserAdmin = (useCached = true) => {
    return useGetEndpointActive('/api/1/admin/user', useCached);
};

const useGetUserPrices = (useCached = true) => {
    return useGetEndpointActive('/api/1/payments/user/prices', useCached);
};

const useGetUserDocumentPdf = (useCached = true) => {
    return useGetEndpointActive('/api/1/user/get_user_document_pdf', useCached);
};

const useGetRotateImage = (useCached = false, cache = false) => {
    return useGetEndpointActive('/api/1/user/image/rotate', useCached, cache);
};

const useGetMMLDActive = (useCached = true) => {
    return useGetEndpointActive('/api/1/user/fetch_mmld_all', useCached);
};

// must use get(null, `${orgId}/user/${userId}`)
const useGetPortalOrgUserActive = (useCached = true) => {
    return useGetEndpointActive('/api/1/portal/organization/', useCached);
};

const useGetPortalAdminUserDetailActive = (useCached = true) => {
    return useGetEndpointActive('/api/1/portal/', useCached);
};

export default useGetEndpointActive;
export {
    useGetUserAdmin,
    useGetUserPrices,
    useGetRotateImage,
    useGetUserDocumentPdf,
    useGetMMLDActive,
    useGetPortalOrgUserActive,
    useGetPortalAdminUserDetailActive,
};
